'use strict';

// ResponsiveTable class
export default class ResponsiveTable {
  // Constructor
  constructor(tableElement, tableContainerClass) {
    // Store reference to table element

    //if (typeof tableElement === '')
    if (typeof tableElement !== 'object') {
      console.error('Table is not a valid Object');
      return null;
    }
    this.el = tableElement;

    this.isFirstColumnFixed = this.el.parentNode.classList.contains('cms-table-rsp--fixed-first-column');

    // Reset display and overflows when javascript is available
    this.el.style.display = 'table';
    this.el.style.overflow = 'visible';
    this.el.setAttribute('border', '0');
    this.el.parentNode.style.overflow = 'visible';

    var tableContainer = document.createElement('div');
    tableContainer.setAttribute('class', tableContainerClass);
    this.el.parentNode.appendChild(tableContainer);
    tableContainer.appendChild(this.el);
    this.tableContainer = tableContainer;

    // Create a scroll indicator and append to table's container
    var scrollIndicator = document.createElement('div')
    scrollIndicator.setAttribute('class', 'scroll-indicator');
    scrollIndicator.innerHTML = '<div class="arrow"></div>';
    this.scrollIndicator = scrollIndicator;
    this.tableContainer.parentNode.appendChild(this.scrollIndicator);
    this.tableContainer.addEventListener('scroll', () => {
      this.onScroll();
    });

    if (this.isFirstColumnFixed) {
      var tableHeaders = this.el.querySelectorAll('tr > :first-child');
      var tableHeaderContainer = document.createElement('div');
      tableHeaderContainer.setAttribute('class', 'cms-table-header-container');
      
      var tempTableHeader = undefined;
      for (var i = 0, len = tableHeaders.length; i < len; i++) {
        tempTableHeader = document.createElement('div');
        tempTableHeader.setAttribute('class', 'cms-table-header');
        tempTableHeader.setAttribute('aria-hidden', 'true');
        tempTableHeader.style.textAlign = tableHeaders[i].style.textAlign;
        tempTableHeader.innerHTML = tableHeaders[i].innerHTML;
        tableHeaderContainer.appendChild(tempTableHeader);
      }
      this.tableContainer.parentNode.appendChild(tableHeaderContainer);
      this.tableHeaderContainer = tableHeaderContainer;
  
      this.tableHeaders = tableHeaders;
    }


    this.renderScrollIndicator();
    this.onScroll();
  }

  getTableWidthDiff() {
    return this.el.offsetWidth - 
      (this.tableContainer.offsetWidth + 
      (this.isFirstColumnFixed ? this.tableHeaderContainer.offsetWidth : 0));
  }

  // Show/hide scroll indicator
  showScrollIndicator(show) {
    if (show && (this.scrollIndicator.className.indexOf('hide') >= 0)) {
      this.scrollIndicator.setAttribute('class', 'scroll-indicator');
    } else if (!show && (this.scrollIndicator.className.indexOf('hide') < 0)){
      this.scrollIndicator.setAttribute('class', 'scroll-indicator hide');
    }
  }

  showTableHeaders() {
    if (this.tableHeaderContainer &&
      this.tableHeaderContainer.childNodes.length > 1 &&
      this.tableHeaderContainer.style.display !== 'flex') {

      this.tableHeaderContainer.style.display = 'flex';

      for (var i = 0, len = this.tableHeaders.length; i < len; i++) {
        this.tableHeaders[i].style.visibility = 'hidden';
        this.tableHeaders[i].setAttribute('aria-hidden', 'false');
      }

    }
  }

  // On scroll event for table container that shows/hides scroll indicator
  // and updates position of table headers
  onScroll() {
    var currentScrollDiff = this.tableContainer.scrollWidth - this.tableContainer.scrollLeft;
    this.renderScrollIndicator(currentScrollDiff > this.tableContainer.offsetWidth);
    if (this.isFirstColumnFixed) {
      this.renderTableHeaders();
      this.showTableHeaders();
    }
  }

  // Renders sticky table headers by resizing them to match the table's actual
  // headers
  renderTableHeaders() {
    const firstTableHeader = this.el.querySelector('tr:first-child > :first-child');
    const tableHeaders = this.el.querySelectorAll('tr > :first-child');
    const dupTableHeaders = this.tableHeaderContainer.querySelectorAll('.cms-table-header');
    this.tableHeaderContainer.style.height = this.el.offsetHeight + 'px';
    for (var i = 0, len = tableHeaders.length; i < len; i++) {
      dupTableHeaders[i].style.height = tableHeaders[i].offsetHeight + 'px';
    }
  
    if(firstTableHeader &&
        (firstTableHeader.offsetWidth - 1 !== this.tableHeaderContainer.offsetWidth)) {
      const firstHeaderWidth = (firstTableHeader.offsetWidth + 2);
      this.tableHeaderContainer.style.width = firstHeaderWidth + 'px';
      if (this.el.offsetWidth - this.tableContainer.offsetWidth >= 5) {
        this.tableContainer.style.marginLeft = firstHeaderWidth + 'px';
        this.tableContainer.style.maxWidth = 'calc(100% - ' + firstHeaderWidth + 'px)';
        this.el.style.marginLeft = '-' + firstHeaderWidth + 'px';
        this.el.style.width = 'calc(100% + ' + firstHeaderWidth + 'px)';
      } else {
        this.tableContainer.style.marginLeft = '0';
        this.tableContainer.style.maxWidth = '100%';
        this.el.style.marginLeft = '0';
        this.el.style.width = '100%';
      }
    }
  }
  // Renders scoll indicator by repositioning and showing/hiding it
  renderScrollIndicator(showScrollIndicator) {
    if (showScrollIndicator === undefined) {
      this.showScrollIndicator(this.getTableWidthDiff() >= 5);
    }
    else {
      this.showScrollIndicator(showScrollIndicator);
    }
  }

  // Renders all sticky elements with default settings
  render(){
    if (this.isFirstColumnFixed) {
      this.renderTableHeaders();
    }
    this.renderScrollIndicator();
  }
}

// Store references to all tables on page
var tables = [];

// Re-renders all tables' sticky elements
function renderAllTables() {
  tables.forEach(table => table.render());
}

// Gets all table elements and stores in array
// Runs initial sticky elements render
// and adds event listener to window resize
export function init() {
  if ('querySelectorAll' in document) {
    var responsiveTables = document.querySelectorAll('.cms-table-rsp table');
    if (responsiveTables && responsiveTables.length > 0) {
      for (var i = 0, len = responsiveTables.length; i < len; i++) {
        if (responsiveTables[i].parentNode.getAttribute('class') !== 'cms-responsive-table-container') {
          tables.push(new ResponsiveTable(responsiveTables[i], 'cms-responsive-table-container'));
        }
      }
    }
    if (tables.length > 0) {
      window.addEventListener('resize', renderAllTables);
      window.addEventListener('load', renderAllTables);
    }
  }
}

init();
